import { Actions, thunk } from 'easy-peasy';
import api from '~/services/api';
import { IClientDetailsActions, IThunkGetMedication } from '../types';

const onGetMedication: IThunkGetMedication = thunk(
  async ({ setCurrent }: Actions<IClientDetailsActions>, payload) => {
    const current = await api.clientDetails.getClientMedication(payload).then(r => r.data);

    setCurrent(current);
  },
);

export default onGetMedication;
